<template>
    <div class="flex items-center justify-center h-screen text-lg font-bold text-blue-500">
        Please wait while the system fetches the tenant data...
    </div>
</template>

<script>

export default {
    components: {
    },
    props: ['re_url'],
    mounted() {
        document.getElementById('full_loader').style.display = "flex";
        window.location.href = this.re_url;
    }

};
</script>
